import styled from '../../../../../../styles/styledComponents/themeComponents';

export const PreviewWrapper = styled.div`
  padding: 10px 15px;
`;

export const NoticeWrapper = styled.div`
  margin-bottom: 40px;
`;

export const NoticeText = styled.p`
  font-size: 11px;
  color: #6410e1;
  margin-bottom: 0;
`;
